export enum SearchTypeEnum {
  UNDEFINED = -1,
  TAXID = 1,
  SPECIALTY,
  NAME
}
